import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Request from './pages/Request';
import Calculator from './pages/Calculator';
import FreelancerProfile from './pages/FreelancerProfile';
import Login from './pages/Login';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminResetPassword from './pages/AdminResetPassword';
import FreelancerLogin from './pages/FreelancerLogin';
import FreelancerDashboard from './pages/FreelancerDashboard';
import ResetPassword from './pages/ResetPassword';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Services from './pages/Services';
import Team from './pages/Team';
import Cookies from './pages/Cookies';
import AGB from './pages/AGB';
import Widerruf from './pages/Widerruf';
import CookieConsent from './components/CookieConsent';
import ChatbotWidget from './components/ChatbotWidget';
import './App.css';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CookieConsent />
        <ChatbotWidget />
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/request" element={<Request />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/calculator/:teamId" element={<Calculator />} />
          <Route path="/freelancer/:freelancerId/profile" element={<FreelancerProfile />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          
          {/* Admin */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          
          {/* Unified Login */}
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Customer */}
          <Route path="/customer/dashboard" element={<CustomerDashboard />} />
          
          {/* Freelancer */}
          <Route path="/freelancer/login" element={<Navigate to="/login?type=freelancer" replace />} />
          <Route path="/freelancer/dashboard" element={<FreelancerDashboard />} />
          <Route path="/freelancer/reset-password" element={<ResetPassword />} />
          <Route path="/freelancer/apply" element={<Navigate to="/team?apply=true" replace />} />
          
          {/* Legal */}
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/widerruf" element={<Widerruf />} />
          
          {/* Fallback - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
